import React from 'react';
import { useTranslation } from 'react-i18next';
import './TranscriptPanel.css';

const TranscriptPanel = ({ transcript, onClose }) => {
  const { t } = useTranslation();
  const formatTime = (timestamp) => {
    return timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  const downloadTranscript = () => {
    if (transcript.length === 0) {
      alert(t('transcript.noData'));
      return;
    }

    const transcriptText = transcript.map(entry => 
      `[${formatTime(entry.timestamp)}] ${entry.speaker}: ${entry.text}`
    ).join('\n\n');

    const blob = new Blob([transcriptText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `interview-transcript-${new Date().toISOString().split('T')[0]}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const clearTranscript = () => {
    if (window.confirm('Are you sure you want to clear the transcript? This action cannot be undone.')) {
      // For now, we'll just close the panel since we can't modify the ChatContext messages from here
      // In a real implementation, you'd want to add a clearTranscript function to ChatContext
      onClose();
    }
  };

  return (
    <div className="transcript-panel">
      <div className="transcript-header">
        <h3>{t('transcript.title')} ({transcript.length} messages)</h3>
        <button className="close-btn" onClick={onClose} title={t('common.close')}>
          &times;
        </button>
      </div>
      
      <div className="transcript-content">
        {transcript.length === 0 ? (
          <p className="no-transcript">{t('transcript.empty')}</p>
        ) : (
          transcript.map((entry, index) => {
            const speakerKey = entry.speaker.toLowerCase();
            const speakerName = t(`transcript.speakers.${speakerKey}`, { defaultValue: entry.speaker });
            
            return (
              <div key={index} className="transcript-entry">
                <span className="transcript-time">[{formatTime(entry.timestamp)}]</span>
                <span className={`transcript-speaker ${speakerKey}`}>
                  {speakerName}:
                </span>
                <span className="transcript-text">{entry.text}</span>
              </div>
            );
          })
        )}
      </div>
      
      <div className="transcript-footer">
        <button 
          className="download-btn" 
          onClick={downloadTranscript}
          disabled={transcript.length === 0}
          title={t('transcript.buttons.downloadTitle')}
        >
          📥 {t('transcript.buttons.download')}
        </button>
        <button 
          className="clear-btn" 
          onClick={clearTranscript}
          disabled={transcript.length === 0}
          title={t('transcript.buttons.clearTitle')}
        >
          🗑️ {t('transcript.buttons.clear')}
        </button>
      </div>
    </div>
  );
};

export default TranscriptPanel;